/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Black (#000) on white (#fff) gives the maximum 21:1 ratio.`)
};

const es_cc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negro (#000) sobre blanco (#fff) da el ratio máximo de 21:1.`)
};

const de_cc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwarz (#000) auf Weiß (#fff) ergibt das maximale Verhältnis von 21:1.`)
};

const nl_cc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwart (#000) op wit (#fff) geeft de maximale verhouding van 21:1.`)
};

const fr_cc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noir (#000) sur blanc (#fff) donne le ratio maximal de 21:1.`)
};

const it_cc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nero (#000) su bianco (#fff) dà il rapporto massimo di 21:1.`)
};

const pt_br2_cc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preto (#000) sobre branco (#fff) dá a taxa máxima de 21:1.`)
};

const pt_cc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preto (#000) sobre branco (#fff) dá o rácio máximo de 21:1.`)
};

const ja_cc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`白(#fff)に黒(#000)を組み合わせると最大の21:1になります。`)
};

const zh_cc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`黑色（#000）配白色（#fff）达到最高的 21:1 对比度。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_ex1", locale)
	if (locale === "en") return en_cc_ex1(inputs)
	if (locale === "es") return es_cc_ex1(inputs)
	if (locale === "de") return de_cc_ex1(inputs)
	if (locale === "nl") return nl_cc_ex1(inputs)
	if (locale === "fr") return fr_cc_ex1(inputs)
	if (locale === "it") return it_cc_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_cc_ex1(inputs)
	if (locale === "pt") return pt_cc_ex1(inputs)
	if (locale === "ja") return ja_cc_ex1(inputs)
	return zh_cc_ex1(inputs)
};